import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import deleteItemField from 'owa-service/lib/factory/deleteItemField';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import itemId from 'owa-service/lib/factory/itemId';
import itemChange from 'owa-service/lib/factory/itemChange';
// Import functions
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
// Import utils
import { utcPinnedEwsTimeStamp } from 'owa-mail-list-store/lib/utils/pinningUtils';
function createRequestBody(itemIdsToUpdate, shouldMarkAsPinned) {
    var itemChanges = [];
    for (var _i = 0, itemIdsToUpdate_1 = itemIdsToUpdate; _i < itemIdsToUpdate_1.length; _i++) {
        var messageItemId = itemIdsToUpdate_1[_i];
        var update = void 0;
        var propertyName = 'RenewTime';
        if (shouldMarkAsPinned) {
            // Set renew time to pin time
            update = createSetItemField(propertyName, utcPinnedEwsTimeStamp);
        }
        else {
            // Remove renew time property
            update = deleteItemField({
                Path: propertyUri({ FieldURI: propertyName }),
            });
        }
        var singleItemChange = itemChange({
            Updates: [update],
            ItemId: itemId({
                Id: messageItemId,
            }),
        });
        itemChanges.push(singleItemChange);
    }
    return updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
export default function markItemsAsPinnedService(itemIdsToUpdate, shouldMarkAsPinned) {
    var requestBody = createRequestBody(itemIdsToUpdate, shouldMarkAsPinned);
    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    var jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return updateItemOperation({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=markItemsAsPinnedService.js.map